$(function(){

  setTimeout(function(){
    $("#flash_notice, #flash_error").fadeTo(4000, 0).animate({ height: 0, padding: 0, margin: 0 }, 500)
  }, 5000);

  // Show or hide the left sidebar
  $('#toggler').on('click', function() {
    var $info = $('#info');
    var $toggler = $('#toggler');
    var $togglerIcon = $toggler.find('i');
    if ($info.hasClass('hidden')) {
      $info.removeClass('hidden');
      $togglerIcon.removeClass('fa-angles-right').addClass('fa-angles-left');
      $toggler.css('left', '100%');
    } else {
      $info.addClass('hidden');
      $togglerIcon.removeClass('fa-angles-left').addClass('fa-angles-right');
      $toggler.css('left', '0');
    }
  });
});

if (typeof(google) == 'undefined')
  return;
beef = {
  variables: {
    markers: {},
    kmls: {},
    lines: {},
    info: new google.maps.InfoWindow({content: ""}),
    commentHeader: document.createElement("h2"),
    polyline: new google.maps.Polyline({
      strokeColor: 		"#ff0000",
      strokeOpacity: 	0.9,
      strokeWeight: 	3,
      map: 				window.map 
    }),
    polylinePath: Object,
    visibleComments: true,
    kmlInteractive: false,
    drawingMode: false
  },

  defaults: {
    zoom:           5,
    lat:            45,
    lng:            -90,
    type:           google.maps.MapTypeId.ROADMAP,
    scrollwheel: 	true,
    doubleclick: 	false,
    id:             "map"
  },

  load: function(){
    map = new google.maps.Map(document.getElementById(this.defaults.id), {
      zoom: 								this.defaults.zoom,
      center: 								new google.maps.LatLng(this.defaults.lat, this.defaults.lng),
      tilt:                                 0,
      mapTypeId: 							this.defaults.type,
      disableDoubleClickZoom:               !this.defaults.doubleclick,
      scrollwheel:      				    this.defaults.scrollwheel,
      mapTypeControlOptions: {
        mapTypeIds: [
          google.maps.MapTypeId.TERRAIN,
          google.maps.MapTypeId.SATELLITE,
          google.maps.MapTypeId.HYBRID,
          'topography',
          google.maps.MapTypeId.ROADMAP
        ]
      }
    });

    geoXml = new geoXML3.parser({
      map: map,
      singleInfoWindow: true
    });

    beef.variables.info.addListener("closeclick", function(){
      beef.undo();
    });

    beef.topo();
  },

  infoWindow: {
    open: function(id, info){
      if (typeof(id) == "number") {
        beef.setHeader("Existing Comment");
        beef.variables.info.setContent(info);
      }
      else {
        let form = document.getElementById("comments").cloneNode(true);
        form.id = "comments_" + id;
        $(form).find('form').first().data("remote", "true");
        if (info == "lines"){
          $(form).find("#line-instructions").removeClass("hidden");
        }
        beef.variables.info.setContent(form);
        
        if (id == "reply") {
          beef.setHeader("Comment Reply");
        }
        if (id == "new") {
          beef.setHeader("Add Comment");  
        }
      }
      beef.variables.info.open(map, beef.variables.markers[id]);
    },
    listener: function(id, info){
      google.maps.event.addListener(beef.variables.markers[id], "click", function(e){
        if (beef.variables.drawingMode) {
          google.maps.event.trigger(map, 'click', e);
          return;
        }
        beef.infoWindow.open(id, info);
      })
    } 
  },

  markers: {
    populate: function(markers){
      jQuery.each(markers, function(key, marker){
        beef.variables.markers[marker.id] = new google.maps.Marker({
          position: new google.maps.LatLng(marker.lat, marker.lng),
          map:      map,
          cursor:   "pointer",
          icon:     marker.icon
        });
        beef.infoWindow.listener(marker.id, marker.info)
      })
    }
  },

  polylines: {
    populate: function(lines){
      let lineSymbol = {
        path: 'M 0,-.7 0,.7',
        strokeOpacity: 0.8,
        scale: 5
      };
      jQuery.each(lines, function(key, line){
        var latlngs = jQuery.map(line.path, function(point, key){
          return new google.maps.LatLng(parseFloat(point[0]), parseFloat(point[1]))
        });

        if (line.dashed) {
          beef.variables.lines[line.id] = new google.maps.Polyline({
            strokeColor: 		line.color,
            strokeOpacity: 	0,
            icons: [{
              icon: lineSymbol,
              offset: '0',
              repeat: '20px'
            }],
            path: 			latlngs
          });
        }
        else {
          beef.variables.lines[line.id] = new google.maps.Polyline({
            strokeColor: 		line.color,
            strokeOpacity: 	0.8,
            strokeWeight: 	5,
            path: 			latlngs
          });
        }
        beef.variables.lines[line.id].setMap(map);
        google.maps.event.addListener(beef.variables.lines[line.id], "click", function(e){
          if (beef.variables.drawingMode) {
            // In drawing mode, click through the feature
            google.maps.event.trigger(map, 'click', e);
          } else {
            beef.variables.info.setContent(line.info);
            beef.variables.info.setPosition(e.latLng);
            beef.variables.info.open(map);
          }
        });

        google.maps.event.addListener(beef.variables.lines[line.id], "mouseover", function(e){
          if (!beef.variables.drawingMode) {
            beef.variables.lines[line.id].setOptions({strokeWeight: 8});
          }
        })

        google.maps.event.addListener(beef.variables.lines[line.id], "mouseout", function(e){
          beef.variables.lines[line.id].setOptions({strokeWeight: 5});
        })

      })
    },
    startDrawing: function() {
      beef.variables.markers["new"]?.setMap(null); // Remove any existing marker
      beef.variables.drawingMode = true;
      beef.variables.polylinePath = beef.variables.polyline.getPath();
      beef.variables.polyline.setMap(map);
      google.maps.event.addListener(map, "click", beef.polylines.addLatLng);
      beef.toggleNote(null); // Clear the note field when starting to draw a line
    },
    addLatLng: function(event){
      event.stop(); // Prevents clicking on map POI from interrupting the line making
      beef.variables.polylinePath.push(event.latLng);
      if (beef.variables.polylinePath.getLength() == 1) {
          beef.variables.markers["new"] = new google.maps.Marker({
            map:      map,
            position: event.latLng
          });
        $("#comments_new #line-undo").addClass("hidden");
        beef.infoWindow.open("new", "lines");
        beef.setHeader("Add Comment Point"); 
        beef.variables.info.content.querySelector("#comment_lat").value = event.latLng.lat();
        beef.variables.info.content.querySelector("#comment_lng").value = event.latLng.lng();
      }
      beef.polylines.saveLine();
      // If the polyline has more than one point, remove the lat/lng from the form and show the undo button
      if (beef.variables.polylinePath.getLength() > 1) {
        beef.setHeader("Add Comment Line"); 
        $("#comments_new #comment_lat, #comments_new #comment_lng").val("");
        beef.variables.markers["new"].setVisible(false);
        $("#comments_new #line-undo").removeClass("hidden");
      }
      beef.variables.markers["new"].setPosition(event.latLng);
      beef.focusComment();
      // Check if the info window is inadvertently closed while drawing a line and undo the comment if so
      if (beef.variables.info.getMap() == null) {
        console.log("Info window no longer open, undoing comment.");
        beef.undo();
      }
    },
    saveLine: function() {
      var $line = $("#comments_new #comment_line");
      $line.val("");
      if (beef.variables.polylinePath.getLength() > 1) {
        beef.variables.polylinePath.forEach(function(element, num){
          $line.val($line.val() + element.lat() + "," + element.lng() + "|");
          if (num == beef.variables.polylinePath.getLength()) {
            $line.val($line.val().substr(0, $line.val().length-2));
          }
        });
      }
    }
  },

  kmls: {
    populate: function(kmls){
      jQuery.each(kmls, function(key, kml){
        // Convert any dashed linework from KML to google maps polyline so dashed style can be applied
        if (kml.dashed) {
          try {
            geoXml.parseKmlString(kml.data.replace(/(\r\n|\n|\r)/gm," "));
            let index = geoXml.docs.length-1
            let lineSymbol = {
              path: 'M 0,-1 0,1',
              strokeOpacity: 1,
              scale: 4
            };
            // Lines
            for (var i = 0; i < geoXml.docs[index].gpolylines.length; i++) {
              geoXml.docs[index].gpolylines[i].setOptions({
                strokeOpacity: 0,
                icons: [{
                  icon: lineSymbol,
                  offset: '0',
                  repeat: '20px'
                }],
                suppressInfoWindows: true,
                clickable:    kml.clickable,
                comments: kml.commentable
              });
              if (beef.variables.kmlInteractivity) {
                google.maps.event.addListener(geoXml.docs[index].gpolylines[i], 'click', function() {
                  openCustomInfoWindow(geoXml.docs[index].gpolylines[i], kml.commentable);
                });
              }
            }
            // Polygons
            for (var i = 0; i < geoXml.docs[index].gpolygons.length; i++) {
              let path = geoXml.docs[index].gpolygons[i].getPath()
              let color = geoXml.docs[index].gpolygons[i].strokeColor;
              geoXml.docs[index].gpolygons[i].setOptions({
                strokeWeight: 3,
                strokeOpacity: 0,
                suppressInfoWindows: true,
                clickable:           kml.clickable,
                comments: kml.commentable
              });
              let pl = new google.maps.Polyline({
                strokeColor: color,
                strokeWeight: 3,
                strokeOpacity: 0,
                icons: [{
                  icon: lineSymbol,
                  offset: '0',
                  repeat: '20px'
                }],
                path: path,
                map: map
              });
              geoXml.docs[index].gpolylines.push(pl);
              if (beef.variables.kmlInteractivity) {
                google.maps.event.addListener(geoXml.docs[index].gpolylines[i], 'click', function() {
                  openCustomInfoWindow(geoXml.docs[index].gpolylines[i], kml.commentable);
                });
              }
            }
            beef.variables.kmls[kml.id] = geoXml.docs[index];
            if (!kml.enabled) {
              geoXml.hideDocument(geoXml.docs[index]);
            }
          }
          catch (e) {
            console.log('GeoXML3 Parse Error.  Problem with the KML id '+kml.id+' '+e);
            return false;
          }
        }
        // Add the non-dashed linework as a KML layer
        else {
          beef.variables.kmls[kml.id] = new google.maps.KmlLayer(
            kml.url,
            {
              map: (kml.enabled ? map : null),
              preserveViewport: true,
              suppressInfoWindows: true,
              clickable: kml.clickable
            });
        }
        // Add click event and info window
        if (beef.variables.kmlInteractivity) {
          google.maps.event.addListener(beef.variables.kmls[kml.id], 'click', function(kmlEvent) {
            openCustomInfoWindow(kmlEvent, kml.commentable);
          });
        }
      });
    }
  },

  setHeader: function(title) {
    beef.variables.commentHeader.innerText = title; 
    beef.variables.info.setHeaderContent(beef.variables.commentHeader);
  },

  undo: function() {
    // Resets the markers for point placement
    beef.variables.markers["new"]?.setMap(null);
    beef.variables.polyline.setPath(new google.maps.MVCArray());
    beef.variables.info.close();
    beef.variables.drawingMode = false;
    
    // Clear line maker listener
    google.maps.event.clearListeners(map, "click");
    $("#map_lat, #map_lng, #map_zoom, #map_study_area, #comment_lat, #comment_lng, #comment_line, #comment_note").val("");
  },
  // Rollback the last point added to the polyline path. 
  undoLine: function(){
    beef.variables.polylinePath.pop();
    let segments = beef.variables.polylinePath.getLength() -1;
    let point = beef.variables.polylinePath.getAt(segments)
    beef.variables.info.setPosition(point);
    if (segments == 0) {
      $("#comments_new #line-undo").addClass("hidden");
      // Convert to single point.
      $("#comments_new #comment_lat").val(point.lat());
      $("#comments_new #comment_lng").val(point.lng());
      $("#comments_new #comment_line").val(null);
      beef.setHeader("Add Comment Point");
      beef.variables.markers["new"].setPosition(point);
      beef.variables.markers["new"].setVisible(true);
    }
    else {
      beef.polylines.saveLine();
    }
  },

  // Adding new comment points only
  markerListeners: function() {
    google.maps.event.addListener(map, "dblclick", (e) => {
      this.placeMarker(e);
    });
  }, 

  // Adding new comment lines or points
  lineListeners: function() {
    google.maps.event.addListener(map, "dblclick", (e) => {
      beef.polylines.startDrawing();
      beef.polylines.addLatLng(e);
    });
  },

  zoomListener: function(zoomNumber) {
    google.maps.event.addListener(map, 'zoom_changed', function(e) {
    zoomLevel = map.getZoom();
    if (zoomNumber >= zoomLevel && beef.variables.visibleComments) {
      Object.keys(beef.variables.markers).forEach(function (key) {
        beef.variables.markers[key].setVisible(false)
      });
      Object.keys(beef.variables.lines).forEach(function (key) {
        beef.variables.lines[key].setVisible(false)
      });
      beef.variables.visibleComments = false
    } else if (zoomNumber < zoomLevel && !beef.variables.visibleComments) {
      Object.keys(beef.variables.markers).forEach(function (key) {
        beef.variables.markers[key].setVisible(true)
      });
      Object.keys(beef.variables.lines).forEach(function (key) {
        beef.variables.lines[key].setVisible(true)
      });
      beef.variables.visibleComments = true
    }
    });
  },

  searchBox: function(){
    var markers = []
    var input = document.getElementById('pac-input');
    map.controls[google.maps.ControlPosition.TOP_LEFT].push(input);

    var searchBox = new google.maps.places.SearchBox(input);

    // Listen for the event fired when the user selects an item from the
    // pick list. Retrieve the matching places for that item.
    google.maps.event.addListener(searchBox, 'places_changed', function() {
      var places = searchBox.getPlaces();

      if (places.length == 0) {
        return;
      }
      for (var i = 0, marker; marker = markers[i]; i++) {
        marker.setMap(null);
      }

      // For each place, get the icon, place name, and location.
      markers = [];
      var bounds = new google.maps.LatLngBounds();
      for (var i = 0, place; place = places[i]; i++) {
        var image = {
          url: place.icon,
          size: new google.maps.Size(71, 71),
          origin: new google.maps.Point(0, 0),
          anchor: new google.maps.Point(17, 34),
          scaledSize: new google.maps.Size(25, 25)
        };

        // Create a marker for each place.
        var marker = new google.maps.Marker({
          map: map,
          icon: image,
          title: place.name,
          position: place.geometry.location
        });

        markers.push(marker);

        bounds.extend(place.geometry.location);
      }

      map.fitBounds(bounds);
    });

    // Bias the SearchBox results towards places that are within the bounds of the current map's viewport.
    google.maps.event.addListener(map, 'bounds_changed', function() {
      var bounds = map.getBounds();
      searchBox.setBounds(bounds);
    });
  },

  // Set up the form for a comment reply
  commentReply: function(e) {
    $("#comment_lat").val(e.latLng.lat());
    $("#comment_lng").val(e.latLng.lng());
    $("#comment_comment_id").val(e.comment);
    $("#comment_comment_option_id_input, #comment_questions").hide();
    beef.toggleNote(e.commentNote); // set the note field if it exists
    // When not on map view, show the comment form instead of the info window
    if (typeof(map) === 'undefined') {
      $("#comments").show();
    }
    else {
      beef.infoWindow.open("reply");
    }
  },

  // This is called by map double-click event to place a marker when lines are not enabled, 
  // or when a KML feature is comment link is clicked.  Both open a new comment at a single point.
  placeMarker: function(e) {
      beef.variables.markers["new"]?.setMap(null); // remove any existing marker
      $("#comment_lat").val(e.latLng.lat());
      $("#comment_lng").val(e.latLng.lng());
      $("#comment_comment_id").val(null);  // not a reply
      $("#comment_comment_option_id_input, #comment_questions").show();

      beef.variables.markers["new"] = new google.maps.Marker({
        map: 				map,
        position: 	e.latLng
      });
      beef.toggleNote(e.commentNote); // show the note field if it exists
      beef.infoWindow.open("new", null);
      beef.focusComment();
  },

  toggleNote: function(note) {
    $("#comment_note").val(note);
    if (note) {
      $("#comment_note_input").removeClass("hidden");
    }
    else {
      $("#comment_note_input").addClass("hidden");
    }
  },

  focusComment: function() {
    setTimeout(function(){$("#comments_new #comment_body").trigger("focus");}, 100);
  },

  updateForm: function() {
    $("#map_lat").val(map.getCenter().lat());
    $("#map_lng").val(map.getCenter().lng());
    $("#map_zoom").val(map.getZoom());
  },

  toggleKML: function(id) {
    let layer = beef.variables.kmls[id];
    if (layer.hasOwnProperty('url')) {
      // kml layer
      if (layer.getMap() != null) {
        layer.setMap(null);
        $("#kml_" + id).addClass("disabled");
      } else {
        layer.setMap(map);
        $("#kml_" + id).removeClass("disabled");
      }
    }   
    else {
      // geoXml layer (dashed polylines)
      if ((layer.gpolylines.length > 0 && layer.gpolylines[0].getMap() != null) || (layer.gpolygons.length > 0 && layer.gpolygons[0].getMap() != null)) {
        geoXml.hideDocument(layer);
        $("#kml_" + id).addClass("disabled");
      }
      else {
        geoXml.showDocument(layer);
        $("#kml_" + id).removeClass("disabled");
      }
    }
  },
  // Add a topographic map layer to the map
  topo: function() {
    var topo_layer = new google.maps.ImageMapType({
      getTileUrl: function(tile, zoom) {
        return "http://services.arcgisonline.com/ArcGIS/rest/services/USA_Topo_Maps/MapServer/tile/" + zoom + "/" + tile.y + "/" + tile.x
      },
      tileSize: new google.maps.Size(256, 256),
      isPng: true,
      maxZoom: 15,
      minZoom: 5,
      name: "Topography",
      alt: "Detailed topographic maps"
    });
    map.mapTypes.set('topography', topo_layer);
  }
}
toggleQuestionAnswer = function(e) {
  if (e.value == "Text") {
    $("#optional_answers").hide();
  }
  else {
    $("#optional_answers").show();
  }
}

// Clickable KML opens an info window
openCustomInfoWindow = function(kmlEvent, commentable) {
  if (beef.variables.drawingMode) {
    // in drawing mode, click through the feature to the map
    const domEvent = {
      stop: () => {},
      latLng: kmlEvent.latLng || kmlEvent.infoWindow.position
    };
    google.maps.event.trigger(map, 'click', domEvent);
    return;
  }
  // clear any existing comments or info windows
  beef.undo();
  // kmlEvent could be from a KML layer or a GeoXML layer with different structure
  let title = kmlEvent.featureData?.name || kmlEvent.title;
  let html = kmlEvent.featureData?.infoWindowHtml || kmlEvent.infoWindow.content;

  // Parse the HTML to check for the specific table structure
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, 'text/html');
  const table = doc.querySelector('table tbody');
  if (table && table.rows.length > 0 && table.rows[0].cells.length === 1) {
    table.deleteRow(0);
    html = doc.body.innerHTML;
    if (table.rows.length === 1 && table.rows[0].cells.length === 1) {
      const innerTable = table.rows[0].cells[0].querySelector('table');
      if (innerTable) {
        html = innerTable.outerHTML;
      }
    }
  }
  let latLng = kmlEvent?.latLng || kmlEvent.infoWindow.position;
  if (commentable) {
    // Append comment link to KML info window
    let link = document.createElement('a');
    link.setAttribute('href', '#');
    link.classList.add('larger');
    link.setAttribute('onclick', `beef.placeMarker({
        latLng: new google.maps.LatLng(${latLng.lat()}, ${latLng.lng()}), 
        commentNote: "${extractCommentNote(title, html)}"}
      );`);
    const icon = document.createElement('i');
    icon.className = 'fa fa-regular fa-comment';
    link.appendChild(icon);
    link.appendChild(document.createTextNode(' Add Comment'));
    html += link.outerHTML;
  }
  beef.setHeader(title);
  beef.variables.info.setContent(html);
  beef.variables.info.setPosition(latLng);
  beef.variables.info.open(map);
}

extractCommentNote = function(name, tableData) {
  // This searches a KML feature description for a feature identifier in a table.  
  // If found, the identifier value is used as the comment note, otherwise the name is used.
  var potentialIDs = ["ID_Number", "TSP ID", "Location"];
  let note = name;
  let elem = document.createElement('div');
  elem.innerHTML = tableData;
  const table = elem.querySelector("table table") ?? elem.querySelector("table")
  let data = {}
  if(table){
    for (i = 0; i < table.rows.length; i++) {
      cells = table.rows[i].cells;
      data[cells[0].textContent] = cells[1].textContent;
    }
  }
  for (let i = 0; i < potentialIDs.length; i++) {
    let key = potentialIDs[i];
    let value = data[key];
    if (typeof value !== "undefined") {
      note = key + ": " + value;
      break;
    }
  }
  return note;
}
